import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { MsAuthService } from './ms-auth.service';

export interface IToken {
  email: string;
  expires_in: string;
  token_type: string;
  gcpScopeList: any[];
  scopes: string[];
  name: string;
  expiration: number;
}

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private _host = '';
  private _token: IToken | undefined;
  private _tokenTimer: any; // skipcq
  private _msAuthToken: string | null = null;

  // skipcq
  constructor(
    private httpClient: HttpClient,
    private _msAuthService: MsAuthService,
  ) {
    this._msAuthService.silentToken$.subscribe((msToken) => {
      this._msAuthToken = msToken;
    })
  }

  public initialize(): Observable<IToken> {
    if (this._msAuthService.hasToken()) {
      this._host = environment.apigee.host + environment.apigee.tokenPath;
      return this.generateToken();
    } else {
      throw new Error('Not Logged In');
    }
  }

  private generateToken(): Observable<IToken> {
    const options = {
      headers: new HttpHeaders({
        Skip: 'true',
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${this._msAuthToken}`,
        'X-API-Key': `${process.env['NG_APP_CTI_CLIENT_KEY']}`
      }),
      withCredentials: true
    };
    return this.httpClient.post<IToken>(this._host, '', options).pipe(
      map((data) => {
        this._token = data;
        let expireInSeconds = Number.parseFloat(this._token.expires_in);
        this._token.expiration = Date.now() / 1000 + expireInSeconds;
        this.tokenUpdater();
        return data;
      }),
      catchError((e) => {
        return throwError(e);
      })
    );
  }

  private tokenUpdater(): void {
    if (this._tokenTimer) {
      return;
    } else {
      this._tokenTimer = setTimeout(() => {
        clearInterval(this._tokenTimer);
        this._tokenTimer = undefined;
        if (this._token && (Date.now() / 1000) > this._token.expiration) {
          this.generateToken();
          this._token = undefined;
        } else {
          this.tokenUpdater();
        }
      }, 30000);
    }
  }

  public get token(): IToken | null {
    if (this._token) {
      return this._token
    } else {
      return null;
    }
  }
}
